import { __assign } from "tslib";
/* I08 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var ChangeBg = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { fill: "currentColor", fillRule: "evenodd" },
                React.createElement("path", { d: "M2 22.02v-20h6.515l.02-.02.02.02H22v7.201l.071.072-.071.07v12.658H2zM20 5.334L5.314 20.02h3.2L20 8.534V5.333zm0 6.03l-8.657 8.657h3.171L20 14.534v-3.171zm0 6l-2.657 2.657H20v-2.657zM18.485 4.02h-3.142L4 15.363v3.142L18.485 4.02zm-5.971 0H9.343L4 9.363v3.172l8.514-8.515zm-5.999 0H4v2.514L6.515 4.02z" })))));
};
ChangeBg.displayName = 'ChangeBg';
export default ChangeBg;
//# sourceMappingURL=ChangeBg.js.map